export interface PrebuiltTemplate {
    slug: string;
    icon: string;
    name: string;
    description: string;
    badge?: string;
    industry?: string;
    subIndustry?: string;
    fields?: string[];
    regions?: string[];
    minimumPrice?: number;
    // Styling
    borderColor: string;
    borderWidth: string;
    borderRadius: string;
    backgroundColor: string;
    textColor: string;
    labelColor: string;
    buttonBackgroundColor: string;
    buttonTextColor: string;
    inputBackgroundColor: string;
    inputBorderColor: string;
    inputTextColor: string;
    fontFamily: string;
    fontSize: string;
    ctaText: string;
}

export const prebuiltTemplates: PrebuiltTemplate[] = [
    {
        slug: 'panneaux-solaires',
        icon: '☀️',
        name: 'Panneaux solaires',
        description: 'Formulaire optimisé pour la capture de leads panneaux solaires avec tous les champs nécessaires',
        badge: 'Populaire',
        industry: 'Rénovation',
        subIndustry: 'Panneaux solaires',
        fields: ['Prénom', 'Nom', 'Téléphone', 'Email', 'Code postal', 'Statut du bien', 'Budget'],
        minimumPrice: 15,
        borderColor: '#fbbf24',
        borderWidth: '2px',
        borderRadius: '16px',
        backgroundColor: '#fffbeb',
        textColor: '#92400e',
        labelColor: '#78350f',
        buttonBackgroundColor: '#f59e0b',
        buttonTextColor: '#ffffff',
        inputBackgroundColor: '#ffffff',
        inputBorderColor: '#fbbf24',
        inputTextColor: '#92400e',
        fontFamily: 'inherit',
        fontSize: '16px',
        ctaText: 'Obtenir mon devis gratuit',
    },
    {
        slug: 'pompe-chaleur',
        icon: '🌡️',
        name: 'Pompe à chaleur',
        description: 'Formulaire spécialisé pompe à chaleur avec questions sur le type de chauffage actuel',
        industry: 'Rénovation',
        subIndustry: 'Pompe à chaleur',
        fields: ['Prénom', 'Nom', 'Téléphone', 'Email', 'Code postal', 'Statut du bien', 'Type de chauffage actuel'],
        minimumPrice: 18,
        borderColor: '#60a5fa',
        borderWidth: '2px',
        borderRadius: '16px',
        backgroundColor: '#eff6ff',
        textColor: '#1e3a8a',
        labelColor: '#1e40af',
        buttonBackgroundColor: '#3b82f6',
        buttonTextColor: '#ffffff',
        inputBackgroundColor: '#ffffff',
        inputBorderColor: '#60a5fa',
        inputTextColor: '#1e3a8a',
        fontFamily: 'inherit',
        fontSize: '16px',
        ctaText: 'Je souhaite être contacté',
    },
    {
        slug: 'isolation-ite',
        icon: '🏠',
        name: 'Isolation (ITE)',
        description: 'Formulaire dédié à l\'isolation thermique extérieure avec superficie et type de bien',
        industry: 'Rénovation',
        subIndustry: 'Isolation Thermique Extérieure',
        fields: ['Prénom', 'Nom', 'Téléphone', 'Email', 'Code postal', 'Statut du bien', 'Surface habitable'],
        minimumPrice: 12,
        borderColor: '#34d399',
        borderWidth: '2px',
        borderRadius: '16px',
        backgroundColor: '#ecfdf5',
        textColor: '#065f46',
        labelColor: '#047857',
        buttonBackgroundColor: '#10b981',
        buttonTextColor: '#ffffff',
        inputBackgroundColor: '#ffffff',
        inputBorderColor: '#34d399',
        inputTextColor: '#065f46',
        fontFamily: 'inherit',
        fontSize: '16px',
        ctaText: 'Demander mon devis',
    },
    {
        slug: 'renovation-globale',
        icon: '🔨',
        name: 'Rénovation globale',
        description: 'Formulaire polyvalent pour tous types de projets de rénovation énergétique',
        industry: 'Rénovation',
        subIndustry: 'Rénovation globale',
        fields: ['Prénom', 'Nom', 'Téléphone', 'Email', 'Code postal', 'Statut du bien', 'Budget', 'Description du projet'],
        minimumPrice: 20,
        borderColor: '#a78bfa',
        borderWidth: '2px',
        borderRadius: '16px',
        backgroundColor: '#f5f3ff',
        textColor: '#5b21b6',
        labelColor: '#6d28d9',
        buttonBackgroundColor: '#8b5cf6',
        buttonTextColor: '#ffffff',
        inputBackgroundColor: '#ffffff',
        inputBorderColor: '#a78bfa',
        inputTextColor: '#5b21b6',
        fontFamily: 'inherit',
        fontSize: '16px',
        ctaText: 'Recevoir mon estimation',
    },
    {
        slug: 'immobilier',
        icon: '🏡',
        name: 'Immobilier',
        description: 'Formulaire pour projets immobiliers avec budget et type de bien recherché',
        industry: 'Immobilier',
        subIndustry: 'Immobilier neuf',
        fields: ['Prénom', 'Nom', 'Téléphone', 'Email', 'Code postal', 'Type de bien recherché', 'Budget'],
        minimumPrice: 25,
        borderColor: '#fb923c',
        borderWidth: '2px',
        borderRadius: '16px',
        backgroundColor: '#fff7ed',
        textColor: '#9a3412',
        labelColor: '#c2410c',
        buttonBackgroundColor: '#f97316',
        buttonTextColor: '#ffffff',
        inputBackgroundColor: '#ffffff',
        inputBorderColor: '#fb923c',
        inputTextColor: '#9a3412',
        fontFamily: 'inherit',
        fontSize: '16px',
        ctaText: 'Je recherche un bien',
    },
    {
        slug: 'assurance',
        icon: '🛡️',
        name: 'Assurance',
        description: 'Formulaire pour comparer et souscrire à une assurance',
        industry: 'Assurance',
        subIndustry: 'Assurance habitation',
        fields: ['Prénom', 'Nom', 'Téléphone', 'Email', 'Code postal', 'Type d\'assurance', 'Situation actuelle'],
        minimumPrice: 10,
        borderColor: '#94a3b8',
        borderWidth: '2px',
        borderRadius: '16px',
        backgroundColor: '#f8fafc',
        textColor: '#1e293b',
        labelColor: '#334155',
        buttonBackgroundColor: '#475569',
        buttonTextColor: '#ffffff',
        inputBackgroundColor: '#ffffff',
        inputBorderColor: '#94a3b8',
        inputTextColor: '#1e293b',
        fontFamily: 'inherit',
        fontSize: '16px',
        ctaText: 'Comparer les offres',
    },
];
